import moment from "moment";
import { GridOptions } from "ag-grid-community";
import { IdSvrAuthService } from "../../../../auth/idSrvAuthService";
import { LocalStorageService } from "@topline/services/localStorageService";
import { AgGridService } from "@topline/services/agGridService";
import { GridStateService } from "../common/gridState/gridStateService";
import { UserManagerExtension } from "@topline/services/userManagerExtension";
import ng from "angular";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastGridService } from "../../services/forecastGridService";
import { ForecastService } from "../../services/forecastService";
class ForecastListComponentController {
    public forecastFilter: $TSFixMe;
    public currenUsers: $TSFixMe;
    public gridApi: $TSFixMe;
    public agDraftGridOptions: GridOptions;
    private sortModelLocalStorageKey = "draftForecastListSortModel";
    private promiseHandler: $TSFixMe;
    private MasterPAndLExportOfDraftForecasts: boolean;

    static $inject = [
        "$scope",
        "$rootScope",
        "modalService",
        ForecastGridService.componentName,
        ForecastService.componentName,
        "forecastApprovalService",
        angularServicesNames.$translate,
        "AlertService",
        IdSvrAuthService.componentName,
        AgGridService.componentName,
        "forecastReportService",
        UserManagerExtension.componentName,
        LocalStorageService.componentName,
        GridStateService.componentName
    ];

    constructor(
        private $scope: $TSFixMe,
        private $rootScope: ng.IRootScopeService,
        private modalService: $TSFixMe,
        private forecastGridService: ForecastGridService,
        private forecastService: ForecastService,
        private forecastApprovalService: $TSFixMe,
        private $translate: ng.translate.ITranslateService,
        private AlertService: AlertService,
        private authService: IdSvrAuthService,
        private agGridService: AgGridService,
        private forecastReportService: $TSFixMe,
        private UserManagerExtension: UserManagerExtension,
        private localStorageService: LocalStorageService,
        private gridStateService: GridStateService
    ) {}

    $onInit() {
        if (!this.forecastFilter) {
            this.forecastFilter = {
                productCode: "",
                budgetYear: moment().year() + 1
            };
        }

        this.authService
            .hasPermissionAsync("MasterPAndLExportOfDraftForecasts")
            .then(result => (this.MasterPAndLExportOfDraftForecasts = result));

        this.UserManagerExtension.getUserAndSubstitutionMsnuIds().then(users => (this.currenUsers = users));

        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));

        this.initializeGridOptions();
    }

    private initializeGridOptions() {
        this.agDraftGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => this.$translate.instant("FORECAST_LIST.GRID.NAME"),
                    field: "name",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        newRowsAction: "keep"
                    },
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    cellRenderer: params =>
                        params.data
                            ? `<div class="ui-grid-cell-contents"><a href="/forecast/edit/${params.data.id}">${params.value}</a></div>`
                            : ""
                },
                {
                    headerValueGetter: () => this.$translate.instant("FORECAST_LIST.GRID.MODIFICATION_TIME"),
                    field: "modificationTime",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        newRowsAction: "keep"
                    },
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    suppressMenu: true,
                    sort: "desc"
                },
                {
                    headerValueGetter: () => this.$translate.instant("FORECAST_LIST.GRID.CREATED_BY"),
                    field: "productManager",
                    filter: "agTextColumnFilter",
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    filterParams: {
                        newRowsAction: "keep"
                    }
                },
                {
                    headerValueGetter: () => this.$translate.instant("FORECAST_LIST.GRID.MARKET"),
                    field: "marketName",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        newRowsAction: "keep"
                    },
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    },
                    cellRenderer: params => this.renderMarketCell(params)
                },
                {
                    headerValueGetter: () => this.$translate.instant("FORECAST_LIST.GRID.COUNTRY"),
                    field: "marketCountry",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        newRowsAction: "keep"
                    },
                    floatingFilterComponentParams: {
                        suppressFilterButton: true
                    }
                },
                {
                    headerValueGetter: () => this.$translate.instant("ACTIONS"),
                    cellRenderer: () =>
                        `<div class="ui-grid-cell-contents">
                            <a class="remove-item" href="#" ng-click="$ctrl.removeForecast(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.REMOVE' | translate }}"><i class="glyphicon glyphicon-trash"></i></a>
                            <a href="#" ng-if="$ctrl.canSendToApproval(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.SEND_FORECAST_TO_ACCEPTANCE' | translate }}" ng-click="$ctrl.sendToApproval(data)"><i class="glyphicon glyphicon-ok"></i></a>
                            <a href="" ng-if="$ctrl.canDownloadReport(data)" ng-click="$ctrl.downloadReport(data)" data-toggle="tooltip" data-placement="top" title="{{ 'TOOLTIP.PLREPORT' | translate }}"><i class="glyphicon glyphicon-download-alt"></i></a>
                        </div>`,
                    filter: false,
                    sortable: false,
                    suppressMenu: true
                }
            ],
            floatingFilter: true,
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            animateRows: true,
            pagination: true,
            domLayout: "autoHeight",
            rowModelType: "serverSide",
            rowGroupPanelShow: "never",
            suppressMultiSort: true,
            popupParent: document.getElementById("draftforecastGrid")!,
            localeTextFunc: this.agGridService.transalteFunc,
            onGridReady: config => {
                this.gridApi = config.api;
                config.api.setServerSideDatasource(
                    this.forecastGridService.createForecastDraftDataSource(this.forecastFilter)
                );
                config.api.sizeColumnsToFit();

                const sortModel = this.localStorageService.getItem(this.sortModelLocalStorageKey);
                if (sortModel) {
                    this.gridApi.setSortModel(sortModel);
                }

                if (this.forecastFilter.agGridFilterModel) {
                    this.gridApi.setFilterModel(this.forecastFilter.agGridFilterModel);
                }
            },
            onFilterChanged: event => {
                this.forecastFilter.agGridFilterModel = event.api.getFilterModel();
                this.saveGridFilterState();
            },
            onSortChanged: () => {
                const sortModel = this.gridApi.getSortModel();
                this.localStorageService.setItem(this.sortModelLocalStorageKey, sortModel);
            },
            onGridSizeChanged: config => {
                config.api.sizeColumnsToFit();
            }
        };
    }

    public productCodeFilterSelected() {
        this.gridApi.onFilterChanged();
        this.saveGridFilterState();
    }

    public productCodeFilterChanged() {
        this.gridApi.onFilterChanged();
        this.saveGridFilterState();
    }

    public getForecastProductCodes(searchString: string) {
        return this.forecastGridService.searchProductCodes(searchString);
    }

    public budgetYearChanged() {
        this.gridApi.onFilterChanged();
        this.saveGridFilterState();
    }

    public reloadPageSize(value: number) {
        if (this.agDraftGridOptions.api) {
            this.agDraftGridOptions.api.paginationSetPageSize(value);
        }
    }

    public removeForecast(forecast: $TSFixMe) {
        this.modalService.showConfirmationModal(
            {
                text: "FORECAST.FORECAST_REMOVE_MESSAGE",
                title: "FORECAST.FORECAST_REMOVE_TITLE"
            },
            () => this.forecastService.remove(forecast.id).then(() => this.getPage()),
            null,
            "danger"
        );
    }

    public canSendToApproval(forecast: $TSFixMe) {
        return this.currenUsers.includes(forecast.productManagerByMsnuId) && forecast.marketType;
    }

    public sendToApproval(forecast: $TSFixMe) {
        this.promiseHandler = this.forecastApprovalService
            .sendToApproval(forecast.id, forecast.forecastStartDate)
            .then(() => {
                this.AlertService.success(this.$translate.instant("FORECAST_LIST.SEND_TO_APPROVAL"));
                this.getPage();
            });
    }

    public canDownloadReport(forecast: $TSFixMe) {
        return this.MasterPAndLExportOfDraftForecasts && forecast.marketType;
    }

    public downloadReport(entity: $TSFixMe) {
        this.forecastReportService.downloadReport(entity);
    }

    private getPage() {
        this.gridApi.onFilterChanged();
    }

    private renderMarketCell(params: $TSFixMe) {
        return params.data && params.data.marketType
            ? params.data.hasForecastMarketDump
                ? `<div class="ui-grid-cell-contents"><a href="forecast/market-dump/${params.data.id}">${
                      params.data.marketVersion
                          ? `${params.data.marketName}-${params.data.marketVersion}`
                          : params.data.marketName
                  } - ${params.data.creationTime}</a></div>`
                : `<div class="ui-grid-cell-contents"><a href="market/${params.data.marketType.toLowerCase()}/edit/${
                      params.data.marketId
                  }">${
                      params.data.marketVersion
                          ? `${params.data.marketName}-${params.data.marketVersion}`
                          : params.data.marketName
                  }</a></div>`
            : "";
    }

    private saveGridFilterState() {
        this.gridStateService.setItem("draftForecastListFilterState", this.forecastFilter);
    }
}

export class DraftForecastListComponent implements ng.IComponentOptions {
    static componentName = "draftForecastListComponent";
    bindings = { forecastFilter: "<" };
    controller = ForecastListComponentController;
    template = require("./draftForecastListComponent.html");
}

angular.module("topline.modules").component(DraftForecastListComponent.componentName, new DraftForecastListComponent());
